import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/constants/routes";
import { LPages } from "@/components/i18n";
import { cn } from "@/lib/utils";

interface VerifyCTAProps {
  variant: 'upgrade' | 'signup';
  placement: 'experts-page' | 'profile-page';
}

export function VerifyCTA({ variant, placement }: VerifyCTAProps) {
  const href = variant === 'upgrade' ? ROUTES.PLANS : ROUTES.AUTH_SIGNUP;

  if (placement === 'experts-page') {
    return (
      <div className="flex justify-end mb-2">
        <Button variant="outline" size="sm" asChild className="gap-1.5 border-primary/20 bg-primary/5 hover:bg-primary/10 text-primary">
          <Link to={href}>
            <ShieldCheck className="h-3.5 w-3.5" />
            {variant === 'upgrade' ? (
              <LPages id="experts.cta.get_verified" defaultValue="How to get verified?" />
            ) : (
              <LPages id="experts.cta.join_network" defaultValue="Join as Expert" />
            )}
          </Link>
        </Button>
      </div>
    );
  }

  // profile-page: full-width subtle banner
  return (
    <div className={cn(
      "flex items-center gap-3 p-3 rounded-lg",
      "border border-primary/20 bg-primary/5"
    )}>
      <ShieldCheck className="h-4 w-4 text-primary shrink-0" />
      <span className="text-sm text-muted-foreground flex-1">
        <LPages id="experts.cta.profile_verify_description" defaultValue="Get verified to rank higher in expert results and build trust with potential clients." />
      </span>
      <Button variant="outline" size="sm" asChild className="shrink-0 border-primary/20 text-primary hover:bg-primary/10">
        <Link to={ROUTES.PLANS}>
          <LPages id="experts.cta.get_verified_short" defaultValue="Get verified" />
        </Link>
      </Button>
    </div>
  );
}
